export function normalizeAccessToken(rawToken) {
  let token = String(rawToken || '').trim();

  // 兼容历史上被 JSON.stringify 包装后存入 localStorage/账号缓存的 token。
  // JWT 本身不会以引号开头或结尾，因此可以安全地在存储边界去除该包装。
  for (let index = 0; index < 2; index += 1) {
    const isQuoted =
      token.length >= 2 &&
      ((token.startsWith('"') && token.endsWith('"')) ||
        (token.startsWith("'") && token.endsWith("'")));
    if (!isQuoted) break;

    try {
      const parsed = JSON.parse(token);
      token = typeof parsed === 'string' ? parsed.trim() : '';
    } catch (e) {
      token = token.slice(1, -1).trim();
    }
  }

  return token;
}

export function setToken(rawToken) {
  const token = normalizeAccessToken(rawToken);
  localStorage.setItem('token', token);
  return token;
}

export function getToken() {
  return normalizeAccessToken(localStorage.getItem('token'));
}
